import React, { Component } from 'react';
import "./tipbubble.css";


class TipBubble extends Component {
  constructor(props){
      super(props);
   }
  render() {

  let classlist = `tip-bubble ${(this.props.guide === 'isabelle')?this.props.guide:''}`
 return (
      <div className={classlist}>
        <div className="tip-content">{this.props.children}</div>
      </div>
    )
  }
}

export default TipBubble;
